import { SupabaseClient } from '@supabase/supabase-js';
import { NestedSearch } from '@habity/types';

export const updateSearch = async (
  supabase: SupabaseClient,
  searchId: number,
  newData: Partial<NestedSearch | null>
) => {
  const { areaIds, municipalityIds, ...searchData } = newData as NestedSearch;

  // SUPABASE: Convert to server action
  const { error: searchError } = await supabase
    .from('searches')
    .update({
      ...searchData,
      updated_at: new Date().toISOString(),
    })
    .eq('id', searchId);

  if (searchError) {
    console.error('Error updating search:', searchError);
    return { error: searchError };
  }

  if (areaIds) {
    // SUPABASE: Convert to server action
    await supabase.from('search_areas').delete().eq('search_id', searchId);

    if (areaIds.length > 0) {
      // SUPABASE: Convert to server action
      const { error: areasError } = await supabase.from('search_areas').insert(
        areaIds.map((areaId) => ({
          search_id: searchId,
          area_id: areaId,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        }))
      );

      if (areasError) {
        console.error('Error updating areas:', areasError);
        return { error: areasError };
      }
    }
  }

  if (municipalityIds) {
    // SUPABASE: Convert to server action
    await supabase
      .from('search_municipalities')
      .delete()
      .eq('search_id', searchId);

    if (municipalityIds.length > 0) {
      // SUPABASE: Convert to server action
      const { error: municipalitiesError } = await supabase
        .from('search_municipalities')
        .insert(
          municipalityIds.map((municipalityId) => ({
            search_id: searchId,
            municipality_id: municipalityId,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
          }))
        );

      if (municipalitiesError) {
        console.error('Error updating municipalities:', municipalitiesError);
        return { error: municipalitiesError };
      }
    }
  }

  // SUPABASE: Call backend fn instead of sb directly
  const { data, error: fetchError } = await supabase
    .from('searches')
    .select()
    .eq('id', searchId)
    .returns<NestedSearch[]>()
    .maybeSingle();

  return { error: fetchError, data };
};
